const namespace = '[ENTITY_TRUCKS]';

export const FETCH_TRUCKS = `${namespace} FETCH_TRUCKS`;
export const SET_TRUCKS = `${namespace} SET_TRUCKS`;
